/* eslint-disable */
import { Box } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { DocumentsUploadExcel, Loading, AreaHighlight, Highlight, PdfLoader, PdfHighlighter, Popup } from "components";
import { useUtilityBillById } from "hooks";
import { UTILITY_BILL_PAGE } from "pages/authenticated/documents/document-summary-v2/route-consts";
import { getFromLocalStorage, setToLocalStorage } from "utils";

import {
  PDF_DOCUMENT_DEFAULT_HEIGHT,
  PDF_DOCUMENT_DEFAULT_WIDTH,
} from "../consts";

const LoadingPDF = () => (
  <Box
    sx={{
      width: PDF_DOCUMENT_DEFAULT_WIDTH,
      height: PDF_DOCUMENT_DEFAULT_HEIGHT,
      position: "relative",
    }}
  >
    <Loading />
  </Box>
);

interface PdfDocumentProps {
  scale: number;
  file: string;
  onLoadSuccess?: ({ numPages }: { numPages: number }) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  pageNumber?: number;
  width: number;
  isScaleChange: boolean;
  billIdExcel?: any;
}
// eslint-disable-next-line react-hooks/rules-of-hooks

export const PdfDocument: FunctionComponent<PdfDocumentProps> = ({
  scale,
  file,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onLoadSuccess,
  billIdExcel,
  width,
  isScaleChange,
}) => {
  const { billId } = useParams<{ [UTILITY_BILL_PAGE.KEY]: string }>();
  const { data: utilityBill } = useUtilityBillById(billId || "");
  const dataEntries = getFromLocalStorage("dataEntries");
  const dataArray = dataEntries && JSON.parse(dataEntries);

  if (dataArray && Object?.keys(dataArray)?.length > 0) {
    dataArray.id = utilityBill?.documentGuid;
    if (dataArray.original) {
      dataArray.original.id = utilityBill?.documentGuid;
      dataArray.fileName = utilityBill?.filename;
      dataArray.original.fileName = utilityBill?.filename;
    }
    setToLocalStorage("dataEntries", JSON.stringify(dataArray));
  }

  const bboxesotps: any = utilityBill?.opts != null ? utilityBill?.opts : [];
  let bvalue = [];
  try {
    if (bboxesotps.length > 0) {
      bvalue = JSON.parse(bboxesotps);
    }
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }
  const bboxesop = bvalue?.bboxes;

  const BBoxes =
    utilityBill?.bboxes != null ? JSON.parse(utilityBill?.bboxes) : [];
  const dimensionsvalue =
    utilityBill?.dimensions != null ? JSON.parse(utilityBill?.dimensions) : [];
  const searchParams = new URLSearchParams(document.location.search);
  const initialUrl = searchParams.get("url") || file;

  const getDimensions = dimensionsvalue.dimensions;


  const [rerender, setRerender] = useState(true);
  const [extention, setExtention] = useState(true);

  const mergedObject = {
    ...BBoxes,
    ...bboxesop,
  };

  const setBoxes = (bBoxes: any) => {
    ``
    const boxesValues: any = [];
    bBoxes && Object.values(bBoxes)?.map((item: any) => {
      const obj: any = {
        content: {
          text: "",
        },
        position: {
          boundingRect: {
            x1: item?.tlh,
            y1: item?.tlv,
            x2: item?.brh,
            y2: item?.brv,
            width: getDimensions && getDimensions[item?.page]?.Width,
            height: getDimensions && getDimensions[item?.page]?.Height,
          },
          rects: [
            {
              x1: item?.tlh,
              y1: item?.tlv,
              x2: item?.brh,
              y2: item?.brv,
              width: getDimensions && getDimensions[item?.page]?.Width,
              height: getDimensions && getDimensions[item?.page]?.Height
            },
          ],
          pageNumber: item?.page + 1,
        },
      };
      return boxesValues?.push(obj);
    });
    return boxesValues;
  };
  const testHighlights: any = {
    [file]: setBoxes(mergedObject),
  };
  const stateHighlights = {
    highlights: testHighlights[initialUrl]
      ? [...testHighlights[initialUrl]]
      : [],
  };
  const renderTip = () => <div />;
  useEffect(() => {
    if (isScaleChange) {
      setRerender(false);
      setTimeout(() => {
        setRerender(true);
      }, 100);
    }
  }, [scale, isScaleChange]);

  const location = useLocation();

  useEffect(() => {
    if (file) {
      const parts = file.split("?");

      const urlWithoutQuery = parts[0];

      const fileUrl: any = urlWithoutQuery.split("/").pop();

      const fileExtension = fileUrl.split(".").pop().toLowerCase();


      setExtention(fileExtension);

      const segments = location.pathname?.split("/");

      const lastpath = segments[segments.length - 1];
      if (fileExtension === "pdf") {
        setExtention(false);
      } else if (lastpath === "comments" || lastpath === "Data_Entries") {
        setExtention(false);
      } else {
        setExtention(true);
      }
    }
  }, [file, location.pathname]);
  return (
    <Box
      sx={{
        width,
        height: PDF_DOCUMENT_DEFAULT_HEIGHT,
        overflowY: "auto",
        display: "flex",
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      >
        {rerender && !extention ? (
          <PdfLoader url={file} beforeLoad={<LoadingPDF />}>
            {(pdfDocument) => (
              <PdfHighlighter
                pdfDocument={pdfDocument}
                enableAreaSelection={(event) => event.altKey}
                scrollRef={() => { }}
                onSelectionFinished={() => renderTip()}
                pdfScaleValue={String(scale)}
                // eslint-disable-next-line react/no-unstable-nested-components
                highlightTransform={(
                  highlight,
                  index,
                  setTip,
                  hideTip,
                  _viewportToScaled,
                  _screenshot,
                  isScrolledTo,
                ) => {
                  const isTextHighlight = !(
                    highlight.content && highlight.content.image
                  );

                  const component = isTextHighlight ? (
                    <Highlight
                      isScrolledTo={isScrolledTo}
                      position={highlight.position}
                      comment={highlight.comment}
                    />
                  ) : (
                    <AreaHighlight
                      isScrolledTo={isScrolledTo}
                      highlight={highlight}
                      onChange={() => { }}
                    />
                  );
                  return (
                    <Popup
                      popupContent={<div />}
                      onMouseOver={(content) => {
                        setTip(highlight, () => content);
                      }}
                      onMouseOut={hideTip}
                      key={index}
                      // eslint-disable-next-line react/no-children-prop
                      children={component}
                    />
                  );
                }}
                highlights={stateHighlights?.highlights}
                onScrollChange={() => { }}
              />
            )}
          </PdfLoader>
        ) : (
          billIdExcel && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                marginLeft: "100px",
              }}
            >
              <DocumentsUploadExcel billIdExcelId={billIdExcel} />
            </Box>
          )
        )}
      </div>
    </Box>
  );
};
